import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { QSelect } from 'quasar'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTypeAhead',
  props: {
    dropdownOptions: {},
    searchKeys: {},
    selected: {},
    rules: {},
    label: {},
    disable: { type: Boolean }
  },
  emits: ["update:selected", "removed"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emit = __emit
const value = computed({
  get() {
    return props.selected
  },
  set(data) {
    emit('update:selected', data)
  },
})
watch(value, (newValue) => {
  if (typeof inputRef.value !== 'undefined') {
    inputRef.value.updateInputValue('')
    value.value = newValue
  }
})

const options = ref([...props.dropdownOptions])
const inputRef = ref<undefined | QSelect>()
const updateSelected = (val: any) => {
  value.value = val
}
function filterFn(val: string, update: (fn: () => void) => void) {
  options.value = [...props.dropdownOptions]

  if (val === '' || typeof val === 'undefined' || val === null) {
    update(() => {
      options.value = [...props.dropdownOptions]
    })
    return
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const inputRef = ref()

  update(() => {
    const needle = val.toLowerCase()
    options.value = props.dropdownOptions.filter((v: any) => {
      return props.searchKeys.some((key) => {
        if (typeof v[key] === 'string') {
          return v[key].toLowerCase().indexOf(needle) > -1
        }
        if (typeof v[key] === 'number') {
          return String(v[key]).indexOf(needle) > -1
        }
      })
    })
  })
}
__expose({
  validate: () =>
    inputRef.value ? inputRef.value?.validate() : console.log('no input ref exists'),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QSelect), {
    "model-value": value.value,
    ref_key: "inputRef",
    ref: inputRef,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => updateSelected(val)),
    options: options.value,
    filled: "",
    "use-input": "",
    label: _ctx.label,
    "input-debounce": "0",
    onFilter: filterFn,
    color: "accent",
    behavior: "menu",
    rules: _ctx.rules,
    disable: _ctx.disable
  }, _createSlots({ _: 2 }, [
    _renderList(Object.keys(_ctx.$slots), (slot, index) => {
      return {
        name: slot,
        fn: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(slotProps)))
        ])
      }
    })
  ]), 1032, ["model-value", "options", "label", "rules", "disable"]))
}
}

})